// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__BXm2R","title":"Header_title__34k-7","side":"Header_side__3aeIP"};